export default "__VITE_ASSET__BgRkPqeF__"